import DashboardLayout from "@/src/components/layout/DashboardLayout";
import { staticPageApiService } from "@/src/lib/api-services/staticPageApiServices";
import Progressbar from "@/src/components/loading";

const IFRAME_PAGE_SLUGS = ["franchise", "contact-us", "refund-cancellation-policy"];

const QuickLinks = ({ data }) => {
    const imageSrc = "/images/background3.jpg";
    const pageDetails = data;
    const urlSlug = pageDetails?.urlSlug?.toLowerCase();

    if (!pageDetails) {
        return (
            <div className="flex flex-row items-center justify-center w-full h-full">
                <Progressbar />
            </div>
        );
    }
    return (
        <div
            className={`bg-lightGrey min-h-screen py-0 ${
                IFRAME_PAGE_SLUGS.includes(urlSlug) ? urlSlug : ""
            }`}
        >
            <div
                className="relative w-full h-60 sm:h-48 md:h-56 lg:h-60 xl:h-64 bg-cover bg-center flex items-center justify-center"
                style={{
                    backgroundImage: `url(${imageSrc})`,
                }}
            >
                <div className="absolute inset-0 bg-black/50 shadow-custom-md"></div>
                <h1 className="relative text-center text-white text-3xl md:text-4xl lg:text-5xl font-bold">
                    {pageDetails?.pageName}
                </h1>
            </div>
            <div className="w-full md:w-3/5 mx-auto px-4 py-6 mt-4 bg-white/70 rounded-xl shadow-md">
                <div
                    className={`prose prose-sm md:prose lg:prose-lg xl:prose-xl prose-red max-w-none text-black ${
                        urlSlug == "privacy-policy" ? "privacy_policy" : ""
                    }`}
                    dangerouslySetInnerHTML={{ __html: pageDetails?.bodyHtml }}
                />
            </div>
        </div>
    );
};

QuickLinks.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

export default QuickLinks;

// 1. Define getStaticPaths to tell Next.js which slugs to build at build-time.
export async function getStaticPaths() {
    const allSlugs = [
        "about-hod",
        "affordable-diagnostic-services",
        "gallery",
        "contact-us",
        "corporate-enquiry",
        "franchise",
        "privacy-policy",
        "terms-of-use",
        "refund-cancellation-policy",
        "spaces",
        "allergy-panel-test",
    ];

    const paths = allSlugs.map((slug) => ({
        params: { slug },
    }));

    return {
        paths,
        fallback: false,
    };
}

// 2. Then define getStaticProps to fetch data for each specific slug
export async function getStaticProps({ params }) {
    const { slug } = params;
    let data = null;
    try {
        const response = await staticPageApiService.staticPageDetails(slug);
        data = response?.data?.[0];
    } catch (error) {
        console.error(error);
        return {
            notFound: true,
        };
    }

    return {
        props: {
            data: { ...data, routerPath: `pages/${slug}` },
        },
    };
}
